<template>
<div class="wrapper">

    <TopBar />
    <LeftSideBar />

    <!-- content 들어가는 부분 -->
    <router-view />

    <Footer />
</div>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import LeftSideBar from "@/components/common/LeftSideBar";
import Footer from "@/components/common/Footer";

export default {
    components: {
        TopBar,
        LeftSideBar,
        Footer
    },
    async mounted() {
        this.$nextTick(() => {
            console.log("AdminWrapper")
            this.$store.commit("SET_THEME");
        });
    }
};
</script>
